import { ReactTFC } from "../../utils/fp/missing-ts-parts";
import { VideoType } from "@swo/shared";
import { css } from "@emotion/react";
import { SwarovskiOptikVideoPlayer } from "../../components/VideoComponent/VideoComponent";
import { ImageWithFocalPoint } from "../../components/_shared-components/image-related/ImageWithFocalPoint";
import { ContentfulImage } from "../../components/_shared-components/image-related/ContentfulImage";
import { CSS_MQ } from "../../styles/breakpoints";
import { CSS_COLORS } from "../../styles/styles-css-variables";
import React from "react";
import { PDPImagesGridImageT } from "./PDP_Gallery/types";

export const PDPMainImageMobileGalleryElement: ReactTFC<{
  openModal: (url: string) => void;
  element: PDPImagesGridImageT | VideoType;
}> = ({ element, openModal }) => {
  function getElement() {
    switch (element.__typename) {
      case "UtilityVideo": {
        const {
          video: { height, width },
        } = element;
        const isPortraitVideo = height > width;

        return (
          <SwarovskiOptikVideoPlayer
            video={element.video}
            subtitles={element.subtitles}
            sys={{ id: "" }}
            portraitMode={false}
            withPlayerUI={false}
            resolutionPickerStrategy="ceil"
            sharedVideoProps={videoProps}
            mode={isPortraitVideo ? "contain" : "fill"}
            videoClassName={"u-bg-black"}
          />
        );
      }

      case "Image": {
        return typeof element.focalPoint !== "undefined" ? (
          <ImageWithFocalPoint
            requestedWidth={600}
            focalPoint={element.focalPoint}
            css={css`
              overflow: hidden;
            `}
            image={{
              url: element.url,
              title: element.title,
              description: element.description,
              width: element.width,
              height: element.height,
            }}
            lazyLoaded={"lazy"}
            attachPictureStyles={imageWithFocalPointStyles}
            assetId={element.sys.id}
          />
        ) : (
          <ContentfulImage
            assetId={element.sys.id}
            contentfulLink={{ url: element.url, noTransparentBackground: false, requestedWidth: 600 }}
            lazyLoaded={"lazy"}
            sizes={"700px"}
            higherDPI={[0.5, 2]}
            attachPictureStyles={attachPictureStyles}
            css={contentfulImageStyles}
          />
        );
      }
    }
  }

  return (
    <button
      css={css`
        position: relative;
        width: 100%;
        height: 100%;
        display: block;
      `}
      onClick={() => openModal(element.__typename === "UtilityVideo" ? element.video.url : element.url)}
    >
      {getElement()}
    </button>
  );
};

const videoProps = {
  muted: true,
  playsInline: true,
  autoPlay: true,
  loop: true,
  preload: "auto",
};

const attachPictureStyles = css`
  ${CSS_MQ.atLeastMd} {
    border: 1px solid ${CSS_COLORS.Grey0};
    border-radius: 2px;
  }

  display: block;
  height: 100%;
  width: 100%;
  background-color: ${CSS_COLORS.GreenWhite};
`;

const contentfulImageStyles = css`
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
`;

const imageWithFocalPointStyles = css`
  display: block;
  height: 100%;
  width: 100%;
`;
